import { useEffect, useCallback } from 'react';

import { logout, switchTeam } from '../globals-service';
import { createAlert } from '../services/alert-service';

const TeamListeners = ({ eventEmitter, applyStoreAction, currentTeamUrl }) => {
    const teamEdited = useCallback(team => {
        if (team.url && team.url !== currentTeamUrl) {
            switchTeam({
                teamUrl: team.url,
                keepPath: true
            });
        }

        applyStoreAction({
            type: 'TEAM_UPDATE_SOCKET',
            payload: {
                teamUrl: team.url,
                team
            }
        });
    }, [currentTeamUrl, applyStoreAction]);

    const teamRemoved = useCallback(({ url }) => {
        createAlert('error', `You have been removed from the team ${url}`, {
            duration: 3000
        });

        if (url === currentTeamUrl) {
            logout();

            return;
        }

        applyStoreAction({
            type: 'TEAM_REMOVE_SOCKET',
            payload: {
                teamUrl: url
            }
        });
    }, [currentTeamUrl, applyStoreAction]);

    const listen = () => {
        eventEmitter.on('team_edited', teamEdited);
        eventEmitter.on('team_deleted', teamRemoved);

        return () => {
            eventEmitter.off('team_edited', teamEdited);
            eventEmitter.off('team_deleted', teamRemoved);
        };
    };

    useEffect(listen, [eventEmitter, teamEdited, teamRemoved]);

    return null;
}

export default TeamListeners;
